import * as React from "react";

import SellingStatement from "./selling-statement.component";

export default function SellingStatementAdapter({
  abcPantsAbTestFlag,
  abcPantsEducationTest,
  currentVariant,
  deviceType,
  pdpContentfulData,
  pdpWyltLDFlag
}) {
  const { desktopSellingStatement, mobileSellingStatement } =
    pdpContentfulData?.fields?.sellingStatement?.fields || {};
  const hasContentfulData =
    !!desktopSellingStatement || !!mobileSellingStatement;
  const showWylt = pdpWyltLDFlag && hasContentfulData;

  if (
    (!showWylt && !currentVariant?.description) ||
    (abcPantsEducationTest && !!currentVariant)
  )
    return null;
  return (
    <SellingStatement
      abcPantsAbTestFlag={abcPantsAbTestFlag}
      currentVariant={currentVariant}
      desktopCopy={desktopSellingStatement}
      deviceType={deviceType}
      mobileCopy={mobileSellingStatement}
    />
  );
}
